module.exports = {
  schema: {
    name: '商品價格',
    type: 'Object',
    contents: {
      productRef: {
        type: 'ObjectId',
        name: '商品',
        reference: 'products',
        refKeys: ['name'],
        input: 'select',
      },
      pricebookRef: {
        type: 'ObjectId',
        name: '價格表',
        reference: 'pricebooks',
        refKeys: ['name'],
        input: 'select',
      },
      prices: {
        type: 'Number',
        name: '價格',
      },
      // stock: {
      //   type: 'Array',
      //   name: '庫存',
      //   contents: [{
      //     type: 'ObjectId',
      //     reference: 'stocks',
      //     refKeys: ['id'],
      //   }],
      // },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'productRef', width: 100 },
        { key: 'pricebookRef', width: 100 },
        { key: 'prices', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '價格',
          rows: [
            [{ key: 'productRef' }],
            [{ key: 'pricebookRef' }],
            [{ key: 'prices' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/prices.js